module.exports = __webpack_public_path__ + "img/circle-minus-minor 1.0d39e5bc.svg";